import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  message,
  Card,
  Spin,
  Checkbox,
  Row,
  Col,
  Pagination,
  Space,
} from "antd";
import { cyan } from "@ant-design/colors";
import PsContext from "../context";
import axios from "axios";
import $ from "jquery";
const AvatarPaginatedList = forwardRef((props, ref) => {
  const context = useContext(PsContext);
  const {
    countQuery,
    listQuery,
    renderItem,
    allData,
    getTotalData,
    recordsPerRequestOrPage,
    selMembers,
    selAllMembers,
    encryptFields,
    refresh,
    userId,
    listHeading,
    isCheckboxList,
    onCheckedChange,
    onPageChange,
    ...other
  } = props;
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  const [currentids, setCurrentIds] = useState([]);
  const [checkStatus, setCheckStatus] = useState([]);
  const currentTotalRecords = useRef(0);
  const [initLoading, setInitLoading] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);

  useEffect(() => {
    resetResult();
    loadData(1, recordsPerRequestOrPage);
    //loadFullData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useImperativeHandle(ref, () => ({
    getTotalRecords,
    getData,
    getSelected,
    recordCount: 50,
  }));
  //sample usage in parent
  //{InfiniteListRef.current && InfiniteListRef.current.getTotalRecords()}
  const getTotalRecords = () => {
    return currentTotalRecords.current;
  };
  const getSelected = () => {
    return checkedList;
  };
  const getData = () => {
    return data;
  };
  const loadFullData = () => {
    var querylist = listQuery.replace(
      ",row_number() OVER (ORDER BY created_date desc) as row_number, age,COALESCE((SELECT GROUP_CONCAT(package_price SEPARATOR ', ')  FROM orders where member_auto_id=m.id  and order_status='Paid' group by member_auto_id order by is_current_plan),0) as paid_amount,ec.course_name,cs.caste_name,f.father_status,f.father_occupation,f.mother_status,f.mother_occupation,f.brothers,f.brothers_married,f.sisters,f.sisters_married,f.family_type,f.dowry_jewels,f.dowry_property,f.dowry_cash,hb.eating_habits,hb.drinking_habits,hb.smoking_habits,hr.star,hr.patham,hr.raasi,hr.laknam,hr.birth_time,hr.birth_place,hr.dhosam_type,hr.jadhagam_type,hr.raasi_chart,hr.amsam_chart,hr.dasa,hr.dasa_year,hr.dasa_month,hr.dasa_days,p.height,p.weight,p.body_type,p.complexion,p.physical_status,p.physical_status_description,mp.prefered_eating_habits,mp.prefered_smoking_habits,mp.prefered_drinking_habits,mp.prefered_martial_status,CONCAT(mp.age_from,',',mp.age_to) as pref_age,CONCAT(mp.height_from,',',mp.height_to) as pref_height,CONCAT(mp.weight_from,',',mp.weight_to) as pref_weight,mp.prefered_physical_status,mp.prefered_mother_tongue,mp.prefered_religion,mp.prefered_caste,mp.prefered_education,mp.prefered_job_type,mp.prefered_job,mp.prefered_country,mp.prefered_state,mp.prefered_district,CONCAT(mp.income_from,',',mp.income_to) as pref_income,mp.expectation_notes",
      ""
    );
    var reqData = {
      query_type: "query", //query_type=insert | update | delete | query
      query: querylist.replace("{rowNumberVar}", currentTotalRecords.current),
    };
    context.psGlobal
      .apiRequest(reqData, context.adminUser(userId).mode)
      .then((res) => {
        let response = res;
        getTotalData(res);
      })
      .catch((err) => {
        message.error(err);
      });
  };
  const loadData = (page, pageSize) => {
    setInitLoading(true);
    var form = new FormData();
    var reqData = {
      //if array of queries pass [] outside
      query_type: "query",
      query:
        listQuery.replace(
          "{rowNumberVar}",
          ((page - 1) * pageSize).toString()
        ) +
        " LIMIT " +
        (page - 1) * pageSize +
        "," +
        pageSize,
      // table:'test',
      // where:{id:'1'},
      //values:{name:'senthil',age:'13'}
      encrypt: encryptFields,
    };
    // console.log(reqData);
    var currentIds = [];
    form.append("queries", context.psGlobal.encrypt(JSON.stringify(reqData)));
    form.append("mode", "dev");
    axios.post("v1/admin/db-query", form).then((res) => {
      if (res["data"].status === "1") {
        var respdata = res["data"].data;
        setData(respdata);
        //ids in a separate state for checkbox purpose
        res["data"].data.forEach((item) => {
          currentIds.push(item.id);
        });

        setCurrentIds(currentIds);

        var currentsss = [...selAllMembers, ...currentIds];
        let allmembers = [...new Set(currentsss)];

        setIds(allmembers);
        //  setCheckStatus(currentIds)
        setInitLoading(false);
        //  setCheckedList([]);
        setCheckedList(selMembers);

        if (onPageChange) {
          setCheckAll(false);
          const intersection = selMembers
            ? selMembers.filter((element) => currentIds.includes(element))
            : "";

          if (intersection.length > 0) {
            setCheckAll(true);
          }
          if (allData) {
            var alda = allData.concat(res["data"].data);
            let allDatas = [...new Set(alda)];
            onPageChange(page, allDatas, currentIds);
          } else {
            var reponse = res["data"].data;
            onPageChange(page, reponse, currentIds);
          }
        }
      } else {
        setInitLoading(false);
      }
    });
  };

  const resetResult = () => {
    setInitLoading(true);
    //reset records
    var form = new FormData();
    var reqData = {
      //if array of queries pass [] outside
      query_type: "query",
      query: countQuery,
      // table:'test',
      // where:{id:'1'},
      //values:{name:'senthil',age:'13'}
    };
    form.append("queries", context.psGlobal.encrypt(JSON.stringify(reqData)));
    form.append("mode", "dev");
    axios.post("v1/admin/db-query", form).then((res) => {
      if (res["data"].status === "1") {
        currentTotalRecords.current = res["data"].data[0].count;
        getTotalData(res["data"].data[0].count);
        setInitLoading(false);
      } else {
        message.error("Error");
        setInitLoading(false);
      }
    });
  };
  const onCheckChange = (list) => {
    var lists = [...selMembers, ...list];
    let uniqueChars = [...new Set(lists)];

    $("#chkbox:not(:checked)").map(function () {
      var index = uniqueChars.indexOf(this.value);
      if (index > -1) {
        // only splice array when item is found
        uniqueChars.splice(index, 1); // 2nd parameter means remove one item only
        selMembers.splice(index, 1);
      }
    });
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < ids.length);
    setCheckAll(list.length === ids.length);
    onCheckedChange(uniqueChars, data);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? ids : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    if (e.target.checked) {
      onCheckedChange(ids, data);
    } else {
      let idss = ids.filter((el) => !currentids.includes(el));
      onCheckedChange(idss, data, currentids);
    }
  };

  return (
    <>
      <Spin spinning={initLoading}>
        <Card
          bodyStyle={{
            padding: "12px",
            fontWeight: "bold",
            fontSize: "18px",
            color: cyan[7],
          }}
          style={{
            margin: "0px",
            border: "1px solid #d9d9d9",
            borderRadius: "2px",

            //borderRadius: "20px",
          }}
        >
          {isCheckboxList && (
            <Checkbox
              indeterminate={indeterminate}
              onChange={onCheckAllChange}
              checked={checkAll}
            />
          )}
          &nbsp;
          {listHeading} ({currentTotalRecords.current})
          {/*  <MyButton style={{ float: 'right' }} href={"#" + props.match.params.userId + "/admin/members/add-member"}> <i class="fa-solid fa-plus pe-2"></i> Add</MyButton> */}
        </Card>
        {isCheckboxList && (
          <Checkbox.Group
            value={checkedList}
            onChange={onCheckChange}
            style={{ width: "100%" }}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              {data.map((item, index) => {
                return (
                  <Row style={{ background: "#fff" }}>
                    <Col
                      style={{
                        padding: "5px 5px 5px 5px",
                        textAlign: "center",
                      }}
                      span={1}
                    >
                      <Checkbox
                        key={item.id}
                        value={item.id}
                        id="chkbox"
                        noStyle
                      />
                    </Col>
                    <Col span={23}>
                      {renderItem(item, parseInt(item.row_number) - 1)}
                    </Col>
                  </Row>
                );
              })}
            </Space>
          </Checkbox.Group>
        )}
        {!isCheckboxList && (
          <>
            {data.map((item, index) => {
              return renderItem(item, parseInt(item.row_number) - 1);
            })}
          </>
        )}

        <Row style={{ background: "#e6fffb", padding: "5px 10px 10px 5px" }}>
          <Pagination
            hideOnSinglePage={true}
            total={currentTotalRecords.current}
            showSizeChanger
            showQuickJumper
            //showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            showTotal={(total, range) => ` ${total} items`}
            defaultPageSize={recordsPerRequestOrPage}
            defaultCurrent={1}
            onChange={(page, pageSize) => {
              loadData(page, pageSize);
            }}
          />
        </Row>
      </Spin>
    </>
  );
});
export { AvatarPaginatedList };
